import React from 'react';
import './about.css';
// import { Parallax } from "react-scroll-parallax";

function about(props) {
    const english = props.english
    const spanish = props.spanish

    return (
        <div>
            <div id='about-main'>
                <div id='about-left'></div>
                <img id='mobile-about-image' src='https://i.ibb.co/4m8t19h/IMG-3500.jpg' alt='hero'></img>
                <div id='about-center'>

                    

                    {english && (
               <div id='about-center-left'>
               <div id='about-text'><span id='intro-line'>Thank you for visiting! I am glad I was able to draw in your attention.</span> <br></br><br></br>
                   I am Audrey Wright, 28-year-old temptress who enjoys the simple pleasures of life. Let's spend some time together?<br></br><br></br>

                   I radiate confidence, individuality and effortless style. If you're looking for a highly educated woman with whom you can delve into an interesting conversation, then I’m your girl. And yet, I will seduce and enchant you through more than mere conversation during our time together.
                   <br></br><br></br>
With my clever wit and creative spirit, I’ll draw out your hidden desires and satisfy your deepest cravings.
<br></br><br></br>
Our time together is a discerning gentleman’s time well spent.
<br></br><br></br>
                   - Audrey Wright xoxo
               </div>
           </div>
            )}



{spanish && (
               <div id='about-center-left'>
               <div id='about-text'><span id='intro-line'>Hola, gracias por visitarme! Me alegro de haber podido llamar tu atención.</span> <br></br><br></br>
               Me llamo Audrey
Wright, y soy una seductora de 28 años que disfruta a los placeres simples de la vida. Te gusta
pasar un rato juntos?<br></br><br></br>

Irradio confianza, individualidad y estilo natural. Si buscas una mujer de alto nivel educativo con
la que puedas compartir una conversación interesante, soy la chica para ti. Sin embargo, te
seduciré y hechizaré a través de algo más que una mera conversación durante nuestro tiempo
juntos.                  
 <br></br><br></br>
 Con mi ingenio y mi espíritu creativo, sacaré a relucir tus deseos ocultos y satisfaré tus antojos
más profundos.<br></br><br></br>
Nuestro tiempo juntos es un tiempo bien empleado por un caballero (o dama!) exigente.<br></br><br></br>
                   - Audrey Wright xoxo
               </div>
           </div>
            )}

                    <div id='about-center-right'>
                        <img id='desktop-about-image' src='https://i.ibb.co/4m8t19h/IMG-3500.jpg' alt='hero'></img>
                        {/* <Parallax speed={10}>
                        </Parallax> */}
                    </div>
                </div>
                <div id='about-right'></div>
            </div>
        </div>
    );
}

export default about;
